import React, { useState } from 'react';
import './VideosPage.css';
import { VideoContent } from '../types/video';
import { getVideosPageItems } from '../data/videoLibrary';
import VideoPreview from './VideoPreview';

interface VideoItem {
  id: number;
  title: string;
  category: string;
  video: string;
  image: string;
}

interface VideosPageProps {
  onVideoClick?: (video: VideoContent) => void;
}

interface VideoCardProps {
  video: VideoItem;
  onCardClick: () => void;
}

const VideoCard: React.FC<VideoCardProps> = ({ video, onCardClick }) => {
  return (
    <div className="video-card-new" onClick={onCardClick}>
      <div className="video-wrapper">
        <VideoPreview
          video={video.video}
          title={video.title}
          className="video-page-preview"
          showBadge={false}
        />
        <div className="video-badge">{video.category.toUpperCase()}</div>
      </div>
      <div className="video-details">
        <h3>{video.title}</h3>
      </div>
    </div>
  );
};

const VideosPage: React.FC<VideosPageProps> = ({ onVideoClick }) => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const allVideos = getVideosPageItems();

  const categories = [
    { id: 'all', name: 'All Videos', icon: '🎬' },
    { id: 'trailers', name: 'Trailers', icon: '🎭' },
    { id: 'action', name: 'Action', icon: '💥' },
    { id: 'adventure', name: 'Adventure', icon: '🗺️' },
    { id: 'thriller', name: 'Thriller', icon: '👻' }
  ];

  const filteredVideos = selectedCategory === 'all'
    ? allVideos
    : allVideos.filter(video => video.category === selectedCategory);

  return (
    <div className="videos-page-new">
      <div className="videos-content">
        <div className="videos-page-header">
          <h1>Video Library</h1>
          <p>Watch the latest video game content</p>
        </div>

        <div className="category-filters">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={`filter-btn ${selectedCategory === cat.id ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat.id)}
            >
              <span className="filter-icon">{cat.icon}</span>
              <span>{cat.name}</span>
            </button>
          ))}
        </div>

        <div className="videos-grid-new">
          {filteredVideos.map((video) => (
            <VideoCard 
              key={video.id}
              video={video}
              onCardClick={() => onVideoClick?.({
                title: video.title,
                video: video.video,
                image: video.image,
              })}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideosPage;
